var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 10.8307C10.4604 10.8307 10.8335 10.4576 10.8335 9.9974C10.8335 9.53716 10.4604 9.16406 10.0002 9.16406C9.53993 9.16406 9.16683 9.53716 9.16683 9.9974C9.16683 10.4576 9.53993 10.8307 10.0002 10.8307Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 10.8307C16.2937 10.8307 16.6668 10.4576 16.6668 9.9974C16.6668 9.53716 16.2937 9.16406 15.8335 9.16406C15.3733 9.16406 15.0002 9.53716 15.0002 9.9974C15.0002 10.4576 15.3733 10.8307 15.8335 10.8307Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16683 10.8307C4.62707 10.8307 5.00016 10.4576 5.00016 9.9974C5.00016 9.53716 4.62707 9.16406 4.16683 9.16406C3.70659 9.16406 3.3335 9.53716 3.3335 9.9974C3.3335 10.4576 3.70659 10.8307 4.16683 10.8307Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.cea10e797ee64a172191ebe9ea6ce32f.svg";
export { ForwardRef as ReactComponent };